import { PersistConfig } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import storageSession from 'redux-persist/lib/storage/session';
import { IAuthState } from './features/auth.slice';
import { ICommonState } from './features/common.slice';
import { IDashboardState } from './features/dashboard.slice';
import { IDashboardSessionState } from './features/dashboardSession.slice';
import { IEmailState } from './features/email.slice';
import { INotificationsState } from './features/notifications.slice';
import { IPlanState } from './features/plan.slice';
import { ISettingsState } from './features/settings.slice';
import { IShipmentState } from './features/shipment.slice';
import { ISmsState } from './features/sms.slice';
import { ITrackingPageState } from './features/trackingPage.slice';
import { IOnboardingGuideState } from './features/onboardingGuide.slice';
import { IWelcomeState } from './features/welcome.slice';
import { IAiPromoState } from './features/aiPromo.slice';

export const commonPersistConfig: PersistConfig<ICommonState> = {
  key: 'common',
  storage,
  whitelist: ['haveClosedPopup', 'permanentDismissIds', 'dismissIdsCount'],
};

export const trackingPagePersistConfig: PersistConfig<ITrackingPageState> = {
  key: 'trackingPage',
  storage,
  whitelist: ['tabSelected', 'tabConfigurationSelected', 'isDismissEddAppBanner'],
};

export const shipmentPersistConfig: PersistConfig<IShipmentState> = {
  key: 'shipment',
  storage,
  whitelist: ['disabledBtn'],
};

export const settingsPersistConfig: PersistConfig<ISettingsState> = {
  key: 'settings',
  storage,
  whitelist: ['tabSelected', 'trackingLinkSyncCooldownEnd'],
};

export const planPersistConfig: PersistConfig<IPlanState> = {
  key: 'plan',
  storage,
};

export const authPersistConfig: PersistConfig<IAuthState> = {
  key: 'auth',
  storage,
};

export const emailPersistConfig: PersistConfig<IEmailState> = {
  key: 'email',
  storage,
  // emailTemplatesTab is NOT persisted: the route ?receiver= is the source of truth for the
  // active customer/merchant template. A persisted value drifted across reloads and showed
  // the wrong "Send to" + loaded the wrong template.
  whitelist: ['orderStatus', 'haveShownVerifyEmailPopup', 'haveClosedBanner', 'emailTab', 'resendTimeEnd'],
};

export const smsPersistConfig: PersistConfig<ISmsState> = {
  key: 'sms',
  storage,
  whitelist: ['tabSelected', 'orderStatusTabSelected'],
};

export const notificationsPersistConfig: PersistConfig<INotificationsState> = {
  key: 'notifications',
  storage,
  whitelist: ['selectedTab'],
};

export const dashboardPersistConfig: PersistConfig<IDashboardState> = {
  key: 'dashboard',
  storage,
  whitelist: ['haveClosedBanner', 'haveClosedOverQuotaBanner', 'haveClosedRecommendedApps', 'haveClosedConstantFeaturedBanner', 'bannerCloseCount'],
};

// Session-scoped dashboard state (BFS #10 / TR-444). Lives in sessionStorage so a
// dismissed promo banner stays hidden across intra-tab navigation but resets when
// the tab is closed — matching Shopify's definition of "same user session".
export const dashboardSessionPersistConfig: PersistConfig<IDashboardSessionState> = {
  key: 'dashboardSession',
  storage: storageSession,
  whitelist: ['bannerSessionHidden'],
};

export const sessionPersistConfig = {
  key: 'session',
  storage: storageSession,
};

export const welcomePersistConfig: PersistConfig<IWelcomeState> = {
  key: 'welcome',
  storage,
  whitelist: ['isDoneSyncOrders'],
};

export const onboardingGuidePersistConfig: PersistConfig<IOnboardingGuideState> = {
  key: 'onboardingGuide',
  storage,
  whitelist: ['panelOpen'],
};

export const aiPromoPersistConfig: PersistConfig<IAiPromoState> = {
  key: 'aiPromo',
  storage,
  whitelist: ['dismissals'],
};
